<template>
    <div>
        <!--頁首-->
        <Header :header="header"></Header>
        <!--功能列表-->
        <Menulist :menulist="menulist"></Menulist>
        <!--功能列表_RWD-->
        <Menulist_RWD :menulist="menulist"></Menulist_RWD>
        <main class="main">
            <!--網站路徑(麵包屑)-->
            <Sitebar :sider="sider" ></Sitebar>
            <div class="incontall inconbox">
                <SideLeft_List :sideleft="sideleft"></SideLeft_List>
                <SideRight_Content :sideright="sideright" :className="menulist.place"></SideRight_Content>
            </div>
        </main>
        <!--頁尾-->
        <Footer :footer="footer"></Footer>
        <GoTop></GoTop>
    </div>
</template> 
<script>

import Header from '../../components/default/NavBar/Header.vue';
import Menulist from '../../components/default/NavBar/Menulist.vue';
import Menulist_RWD from '../../components/default/NavBar/Menulist_RWD.vue';
import Sitebar from '../../components/default/NavBar/Sitebar.vue';
import SideLeft_List from '../../components/default/Content/SideLeft_List.vue'
import SideRight_Content from '../../components/default/Content/SideRight_Content.vue';
import Footer from '../../components/default/NavBar/Footer.vue';
import GoTop from '../../components/default/Tool/GoTop.vue';

export default{
    components:{
        Header,        
        Menulist,
        Menulist_RWD,
        Sitebar,
        SideLeft_List,
        SideRight_Content,
        Footer,
        GoTop,
    },
    data(){
        return {
            //首頁
            header:{
                text1:"國立臺灣大學生物產業傳播暨發展學系",
                text2:"隱私權及資訊安全政策",
                text3:null,
            },
            //功能列表 &功能列表_RWD
            menulist:{
                place:"Copyright",
            },
            //網站路徑(麵包屑)
            sider:{
                index:2,
                type:0,
                list:[{text:"隱私權及資訊安全政策" ,url:"#"}],
            },
            //左側資料(列表)
            sideleft:{
                title:"隱私權及資訊安全政策",
                list:[],
            },
            sideright:{
                title:"隱私權及資訊安全政策",
                content:'<div class="mb-[15px] text-lg leading-8 sm:text-[0.875rem] sm:leading-[26px] sm:mb-[25px]"><p>歡迎蒞臨「國立臺灣大學生物產業傳播暨發展學系」（以下簡稱本網站），本網站尊重並保護您在使用臺大校園網路時的安全及隱私保護權利，為了幫助您瞭解本網站如何保護您在使用本網站各項服務的安全、及如何蒐集、運用及保護您所提供的資訊，請您詳細閱讀「國立臺灣大學生物產業傳播暨發展學系」的隱私權及資訊安全政策。若對於本網站有任何意見，請E-mail至 <a class="text-lg text-[#666666] underline hover:text-red" title="Email" href="mailto:ntubicd@ntu.edu.tw" target="_blank" rel="noopener">ntubicd@ntu.edu.tw</a>。</p><p class="mb-[15px] mt-[15px] text-xl leading-8 font-bold sm:text-[0.875rem] sm:leading-[26px] sm:mb-[25px]">適用範圍</p><p>本隱私權及資訊安全政策僅適用於您在本網站 ”ntu.edu.tw網域”，以及其延伸服務網站(例如www.cc.ntu.edu.tw)活動時，所涉及的個人資料之收集、運用與保護。但不適用於您經由本網站搜尋連結至其他網站後，所進行之活動，關於您在其他網站的個人資料之保護，適用各該網站的隱私權保護政策。對於不屬於「國立臺灣大學生物產業傳播暨發展學系」之網站或網頁，不論其內容或隱私權政策，均與「國立臺灣大學生物產業傳播暨發展學系」無關。</p><h3 class="mb-[15px] mt-[15px] text-xl leading-8 font-bold sm:text-[0.875rem] sm:leading-[26px] sm:mb-[25px]">一、隱私權宣告</h3><p>為了尊重及保護您的個人隱私權，讓您安心的使用本網站所提供的各項服務及資訊，特此向您說明本網站的隱私權政策，以保障您的權益，請詳閱下列內容：</p><p class="mb-[15px] mt-[15px] ml-[15px] mr-[15px] text-xl leading-8 font-bold sm:text-[0.875rem] sm:leading-[26px] sm:mb-[25px]">資料之蒐集及運用</p><ol class="list-decimal ml-10 mb-8 leading-relaxed"><li>單純瀏覽「國立臺灣大學生物產業傳播暨發展學系」網站及下載檔案之行為，本網站不會蒐集任何與個人身份有關之資訊。</li><li>當您參與本網站之相關服務時，您所提供之資料，我們會遵循中華民國「個人資料保護法」及相關法令規定，不會將其應用在超出收集特定目的以外之用途。</li><li>本網站伺服器自動記錄使用者所閱讀的網頁及瀏覽路徑、使用者的IP位址，僅作為內容與系統改進評估之依據。此統計分析不涉及使用者個人身分資料。</li><li>我們可能會因法律要求，或因遵循適用法律及規範，而必須提供相關資訊。</li><li>我們有權修改這份聲明，並更新與公告於本網站。</li></ol><p>&nbsp;</p><h3 class="mb-[15px] mt-[15px] text-xl leading-8 font-bold sm:text-[0.875rem] sm:leading-[26px] sm:mb-[25px]">二、資訊安全政策</h3><p>任何未經授權而企圖竄改本網站內各項服務之行為，都是嚴厲禁止而且可能觸犯法律。為了網站安全的目的和確保網站之服務能夠正常運作，提供了以下的安全保護措施：</p><ol class="list-decimal ml-6 mb-8 leading-relaxed"><li>裝設防火牆及入侵偵測防禦系統IDP(Intrusion Detection Prevention)防止非法入侵，避免相關資料遭到非法存取使用，以確保網站的安全。</li><li>建置網路流量管理系統，有效管制異常網路流量，以保障網路正常使用。</li><li>建立資訊安全事件監控、通報與應變處理機制，以防有事件發生，可在最短時間內回復運作，降低損害。</li><li>網站資料定期備份，並備份到備援主機。</li><li>設置<a class="text-lg text-[#666666] underline hover:text-red" title="智慧財產權專區(另開新視窗)" href="https://my.ntu.edu.tw/tipa/" target="_blank" rel="noopener">國立臺灣大學保護智慧財產權宣導及推動小組</a>，訂定相關管理辦法及規範，宣導正確的網路使用觀念，並教育使用者尊重智慧財產權。</li></ol><p>&nbsp;</p><h3 class="mb-[15px] mt-[15px] text-xl leading-8 font-bold sm:text-[0.875rem] sm:leading-[26px] sm:mb-[25px]">三、使用條款</h3><ol class="list-decimal ml-6 mb-8 leading-relaxed"><li>使用者之義務及承諾<br>使用者須恪遵『臺灣學術網路管理規範』、本校『國立臺灣大學校園網路使用規範』及相關法令之規定，承諾絕不為任何非法目的或以任何非法方式使用本服務，並承諾遵守中華民國相關法規及一切使用網際網路之國際慣例。您若係中華民國以外之使用者，並同意遵守所屬國家或地域之法令。您同意並保證不得利用本網站從事侵害他人權益或違法之行為，任何危害本網站資訊安全之行為人，視情節輕重追究其法律責任。</li><li>個人自我保護措施<br>請妥善保管帳號、密碼及任何個人資料，切勿將個人資料提供給任何人，尤其是密碼。<br>提醒您於登入本網站所提供之各項服務之網頁後，在離開本網站之前，務必登出(Logout)帳號。若您使用共用或公共電腦(如圖書館、學校電腦教室等)，切記要關閉瀏覽器視窗，以防止他人讀取您的個人資料並保障您的權益。</li></ol><h3 class="mb-[15px] mt-[15px] text-xl leading-8 font-bold sm:text-[0.875rem] sm:leading-[26px] sm:mb-[25px]">四、版權聲明</h3><p>國立臺灣大學全球資訊網內以任何媒體呈現之所有內容，包括文字、音訊、視訊及版面設計，著作權屬國立臺灣大學。任何形式之轉載，請先與我們聯繫。</p><p>Copyright© 2023 National Taiwan University ALL RIGHTS RESERVED</p><h3 class="mb-[15px] mt-[15px] text-xl leading-8 font-bold sm:text-[0.875rem] sm:leading-[26px] sm:mb-[25px]">五、隱私權及安全政策修訂</h3><p>本網站會視需要修改網站上所提供的隱私、安全政策及使用者條款的內容，並公告於本網站中，以維護您瀏覽網站的安全及相關權益，並落實保障網路安全的立意。</p><h3 class="mb-[15px] mt-[15px] text-xl leading-8 font-bold sm:text-[0.875rem] sm:leading-[26px] sm:mb-[25px]">六、隱私權及安全政策諮詢</h3><p>若您對本網站的隱私權及安全政策有任何疑問，請Email至: <a class="text-lg text-[#666666] underline hover:text-red" title="Email" href="mailto:ntubicd@ntu.edu.tw" target="_blank" rel="noopener">ntubicd@ntu.edu.tw</a>，歡迎您隨時與我們聯絡。</p></div>',
                useTag:false,
            },
            //頁尾
            footer:{

            },
            //類別編號
            PJ_ID:"",
            //文章編號,
            type_id:"",
            //語言
            langurage:"1",
        }
    },
    computed:{

    },
    mounted(){
        //初始化
        this.init();
    },
    watch:{
        
    },
    methods:{
        //初始化
        init(){
        },
    }
}

</script>